<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
defineProps({
  show: {
    type: Boolean,
    required: true
  }
})
const elMain = ref()
const denyScrollEvent = (event) => {
  event.preventDefault()
}

onMounted(() => {
  elMain.value.addEventListener('touchmove', denyScrollEvent, { passive: false })
  elMain.value.addEventListener('wheel', denyScrollEvent, { passive: false })
})
onBeforeUnmount(() => {
  elMain.value.removeEventListener('touchmove', denyScrollEvent, { passive: false })
  elMain.value.removeEventListener('wheel', denyScrollEvent, { passive: false })
})
</script>

<template>
  <Transition name="fade">
    <div
      v-show="show"
      ref="elMain"
      class="waitingAsyncActions"
      style="background: rgb(0 0 0 / 20%);"
    >
      <div class="waitingAsyncActions__inner">
        <small class="waitingAsyncActions__text">
          NOW LOADING
          <span class="waitingAsyncActions__dot waitingAsyncActions__dot--1">.</span>
          <span class="waitingAsyncActions__dot waitingAsyncActions__dot--2">.</span>
          <span class="waitingAsyncActions__dot waitingAsyncActions__dot--3">.</span>
        </small>
      </div>
    </div>
  </Transition>
</template>

<style scoped lang="scss">
.waitingAsyncActions{
  z-index: 1000;
  position: fixed;
  background: rgb(0 0 0 / 60%);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  &__inner{
    background: rgb(0 0 0 / 30%);
    height: 52px;
    width: 180px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  &__text{
    font-size: 1.3rem;
    font-weight: var(--fwMedium);
    letter-spacing: 0.08em;
  }

  &__dot{
    text-align: center;
    display: inline-block;
    animation-name: waitingAsyncActionsAnime;
    animation-duration: 0.6s;
    animation-iteration-count: infinite;
    animation-timing-function: ease;
    animation-direction: alternate;
    &--1{ animation-delay: 0.2s; }
    &--2{ animation-delay: 0.4s; }
    &--3{ animation-delay: 0.6s; }
  }
}

@keyframes waitingAsyncActionsAnime {
  0% {opacity: 0;}
  50% {opacity: 0;}
  51% {opacity: 0;}
  100% {opacity: 1;}
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
  opacity: 1;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

</style>
